import { Formik, useFormikContext } from 'formik'
import { ArrowRight } from 'almanac-ui/icons'
import { Form } from '../../Form/Form'
import { Button } from 'blaze-ui/Button'
import { Header as ContentPlanningHeader } from 'components/Wizards/ContentPlanning/Header/Header'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Sections } from 'components/Wizards/Wizard/Form/Sections'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import {
  ConditionalLanguageInputField as LanguageInputField,
  ConditionalInlineLanguageInputField as InlineLanguageInputField,
} from '../../Wizard/Form/LanguageInputField/ConditionalLanguageInputField'
import { multiStep } from 'components/Wizards/MultiStepWizard/multiStep'
import { StepProps } from 'components/Wizards/MultiStepWizard/Types'
import { useEffect } from 'react'
import { MediaType } from 'components/Wizards/schemas/shared/mediaType'

interface Props extends StepProps {
  header: string
  subHeader: string
  onChange: (values: any) => any
}

const ValuesObserver = ({ onChange }: { onChange: (values: any) => any }) => {
  const { values } = useFormikContext()
  useEffect(() => {
    onChange(values)
  }, [values]) // eslint-disable-line
  return null
}

export const ChooseTopic = multiStep<Props>(({ initialValues, onSubmit, header, subHeader, onChange, schema }) => {
  const { isMobile } = useResponsiveDesign()
  const { meta } = schema.describe()

  return (
    <>
      <Formik
        validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={schema.cast({ ...schema.getDefault(), ...initialValues }, { assert: false })}
      >
        {({ submitForm, setFieldValue }) => (
          <Form.Root>
            <ValuesObserver
              onChange={(newValues) => {
                setFieldValue('include_images', newValues.media_type === MediaType.DocumentWithImages)
                onChange(newValues)
              }}
            />
            <Sections.Root schema={schema}>
              <Sections.ManualFieldsSection header={<ContentPlanningHeader header={header} subHeader={subHeader} />} />
              <Sections.AutoFillFieldsSection>
                <ResponsiveDesign.Mobile>
                  <LanguageInputField />
                </ResponsiveDesign.Mobile>
              </Sections.AutoFillFieldsSection>
              <Form.Actions isSticky>
                <Form.PrimaryActions>
                  <ResponsiveDesign.Desktop>
                    <InlineLanguageInputField />
                  </ResponsiveDesign.Desktop>
                  <Button
                    size="lg"
                    onPress={() => {
                      submitForm()
                    }}
                    endIcon={ArrowRight}
                    fullWidth={isMobile}
                  >
                    {meta.submitLabel}
                  </Button>
                </Form.PrimaryActions>
              </Form.Actions>
            </Sections.Root>
          </Form.Root>
        )}
      </Formik>
    </>
  )
})
